import { type LayoutDto } from '@api/devices';
import { PortLayout, SortingType } from '@devices';

export function getPortRows<T>(list: T[], layout?: LayoutDto): T[][] {
  if (!list.length) {
    return [[]];
  }

  if (layout?.type === PortLayout.TWO_ROWS) {
    const count = list.length;
    const perRow = Math.ceil(count / 2);

    if (layout.sortingType === (SortingType.CONSECUTIVE as number)) {
      return [
        list.slice(0, perRow),
        list.slice(perRow),
      ];
    } else {
      const top: T[] = [];
      const bottom: T[] = [];

      for (let i = 0; i < count; i++) {
        if (i % 2 === 0) {
          top.push(list[i]);
        } else {
          bottom.push(list[i]);
        }
      }

      return [top, bottom];
    }
  }

  return [list];
}
